import { PageOverviewLoadingState } from './PageOverviewLoadingState';
import { PageWrapper } from './PageWrapper';

type PageLoadingFallbackProps = {
  label?: string;
  className?: string;
};

export const PageLoadingFallback = ({ label, className }: PageLoadingFallbackProps) => {
  return (
    <PageWrapper className={className}>
      <PageOverviewLoadingState label={label} />
    </PageWrapper>
  );
};
